<script setup lang="ts">
const galleries = [
  {
    src: '/images/about/card-1.webp',
    alt: 'Sharing Session',
    class: '-rotate-[4.9deg]',
    imageWrapper: 'w-[160px] aspect-[200/230]'
  },
  {
    src: '/images/about/card-2.webp',
    alt: 'Mini Soccer Match',
    class: 'rotate-[4.9deg]',
    imageWrapper: 'w-[200px] aspect-[230/170]'
  },
  {
    src: '/images/about/card-3.webp',
    alt: 'KiriminAja 3rd Anniversary',
    class: 'shrink-0 z-5',
    imageWrapper: 'w-[300px] aspect-[360/254]'
  },
  {
    src: '/images/about/card-4.webp',
    alt: 'Team Building',
    class: 'rotate-[-3.85deg] z-4',
    imageWrapper: 'w-[160px] aspect-[230/215]'
  },
  {
    src: '/images/about/card-5.webp',
    alt: 'Business Gathering',
    class: 'rotate-[4.31deg] z-3',
    imageWrapper: 'w-[170px] aspect-[230/215]'
  }
]

const maxHeight = ref(0)
const imageEl = useTemplateRef('image')
watch(
  () => imageEl.value?.offsetHeight,
  (newHeight) => {
    if (newHeight && newHeight > maxHeight.value) {
      maxHeight.value = newHeight
    }
  },
  { immediate: true }
)
</script>
<template>
  <HeroCenter
    title="Kami Mendukung Pengiriman <br/> jadi Lebih Optimal"
    sub-title="Tentang KiriminAja"
    description="KiriminAja mengembangkan teknologi sebagai aggregator jasa pengiriman, membantu tercapainya <br/> pengiriman barang yang efektif dan efisien."
    class="pt-10 lg:py-10"
  >
    <div
      ref="image"
      class="flex mt-5 overflow-auto lg:overflow-hidden -space-x-5 lg:py-10 hover:space-x-2 justify-center relative items-center group"
      :style="{ height: maxHeight ? `${maxHeight}px` : undefined }"
    >
      <div
        v-for="(gallery, index) in galleries"
        :key="index"
        :class="
          cn(
            'bg-background dark:bg-surface-container transition-all p-3 shadow-xl border border-outline-variant pointer-events-none rounded-xl group-hover:rotate-0 group-hover:border-0 group-hover:p-0',
            gallery.class
          )
        "
      >
        <div
          :class="
            cn(
              'rounded-lg overflow-hidden relative group-hover:w-64 group-hover:h-64 transition-all',
              gallery.imageWrapper
            )
          "
        >
          <NuxtImg
            :src="gallery.src"
            :alt="gallery.alt"
            class="absolute bottom-0 h-full max-w-none left-1/2 -translate-x-1/2"
          />
        </div>
        <div
          class="p-3 font-semibold font-display text-sm text-center group-hover:hidden"
        >
          {{ gallery.alt }}
        </div>
      </div>
    </div>
  </HeroCenter>
</template>
